import Notification from "../../components/Notification";
import {useSelector} from "react-redux";
import { selectNotifications } from "../../features/application/applicationSlice";

const Index = () => {
    const notifications = useSelector(selectNotifications)
    return (
        <div id="notifications-container" className="notifications-container">
            {notifications.map((notification) => {
                    if (!notification.viewed) {
                        return <Notification key={notification.id}
                                             notification={notification}
                        ></Notification>
                    }
                    return ''
                }
            )
            }
        </div>
    )


}

export default Index
